 
import http from "@/http/service"
 
const Promocoes =  function (){

    return http.get(`/admin/promocoes`)

}

export default {
    Promocoes, 
}